import { type AutocompleteRenderValueGetItemProps, Chip, autocompleteClasses } from "@mui/material";

export const defaultRenderValue = <T extends { label: string; value: string }>(
  values: T[],
  getTagProps: AutocompleteRenderValueGetItemProps<boolean>
) => {
  return values.map((value, index) => (
    <Chip
      color="secondary"
      label={value.label}
      size="small"
      {...getTagProps({ index })}
      key={`${value.value}-${index}`}
    />
  ));
};

export const defaultTagsStyle = {
  color: "yellow",
  size: "small",
  sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } },
} as const;
